import { render, staticRenderFns } from "./XmGoodsMark.vue?vue&type=template&id=2d86ef6e"
import script from "./XmGoodsMark.vue?vue&type=script&lang=js"
export * from "./XmGoodsMark.vue?vue&type=script&lang=js"
import style0 from "./XmGoodsMark.vue?vue&type=style&index=0&id=2d86ef6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports